import { Button } from "./Button";
import { cn } from "../../utils";
import { MagnifyingGlass, XCircle } from "@phosphor-icons/react";

type SearchProps = {
  className?: string;
  inputClassName?: string;
  onChangeText?: (text: string) => void;
  onReset?: () => void;
  defaultValue?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export function Search({
  className,
  inputClassName,
  onChangeText,
  onChange,
  onReset,
  defaultValue,
  ...props
}: SearchProps) {
  return (
    <div className={cn("min-w-40", className)}>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 start-1 flex items-center ps-3">
          <MagnifyingGlass size={20} alt="Rechercher" />
        </div>
        <input
          type="search"
          id="default-search"
          className={cn(
            "block w-full rounded-lg border-gray-300 bg-gray-100 p-3.5 ps-10 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500",
            { "no-input-cross": !!onReset },
            inputClassName
          )}
          placeholder="Rechercher"
          {...props}
          onChange={(e) => {
            if (onChange) onChange(e);
            if (onChangeText) onChangeText(e.target.value);
          }}
          defaultValue={defaultValue}
        />
        {onReset && (
          <Button
            variant="ghost"
            className="absolute inset-y-0 right-1 my-auto p-1 text-gray-500"
            size="fit"
            onClick={onReset}
          >
            <XCircle size={20} alt="Supprimer le texte" />
          </Button>
        )}
      </div>
    </div>
  );
}

export default Search;
